<template>
  <v-row class="mb-4">
    <v-col cols="12" md="8">
      <v-card
        color="primary"
        class="pa-4 h-100"
        @click="$router.push('/clientServices')"
        style="cursor: pointer;"
      >
        <v-card-title class="text-white d-flex align-center">
          <v-icon class="mr-2" size="large">mdi-magnify</v-icon>
          {{ t.dashboard?.search_client_services || 'Search Client Services' }}
        </v-card-title>
        <v-card-subtitle class="text-white">
          {{ t.dashboard?.search_client_services_desc || 'Search and manage client services' }}
        </v-card-subtitle>
      </v-card>
    </v-col>
    <v-col cols="12" md="4">
      <v-card
        color="success"
        class="pa-4 h-100"
        @click="$emit('show-add-service')"
        style="cursor: pointer;"
      >
        <v-card-title class="text-white d-flex align-center">
          <v-icon class="mr-2" size="large">mdi-plus-circle</v-icon>
          {{ t.dashboard?.add_client_service || 'Add Service' }}
        </v-card-title>
        <v-card-subtitle class="text-white">
          {{ t.dashboard?.add_client_service_desc || 'Add a new service for a client' }}
        </v-card-subtitle>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { t as tRef } from '@/composables/useLanguages'

export default {
  name: 'QuickActionsSection',
  props: {
    config: { type: Object, default: () => ({}) }
  },
  emits: ['show-add-service'],
  computed: {
    t() { return tRef.value }
  }
}
</script>
